import { Component, ChangeDetectionStrategy } from '@angular/core';
import { OptionComponent } from '../abstract/option.component';
import { optionTextRequiredValidator } from './option-text-required-validator.fn';

@Component({
  selector: 'option-text',
  styleUrls: ['./option-text.component.css'], 
  templateUrl: './option-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
 
})
export class OptionTextComponent extends OptionComponent {
  ngOnInit () {
    super.ngOnInit();
    if (this.text) this.text.control.setValidators(optionTextRequiredValidator(this.option));
  }
  refreshView () {
    this.text.control.updateValueAndValidity();
    super.refreshView();
  }
}
